import { css } from 'styled-components';

export default css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  grid-gap: 10px;
  margin: 10px;
  .cx-date-picker {
    width: 100%;
  }
`;
